module.exports = __webpack_public_path__ + "img/1.2f04ee12.jpg";